import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

// Результат модалки блокировки.
export interface LockModalResult {
  reason: string;
  // ISO-строка момента истечения блокировки или null (бессрочно).
  expiresAt: string | null;
}

/**
 * Модалка установки/снятия блокировки: причина + (при установке) срок действия `expiresAt`.
 * `expiresAt` — момент, после которого лок автоматически перестаёт действовать (станет неактивным);
 * пусто = бессрочно (до ручного снятия).
 */
@Component({
  selector: 'app-lock-modal',
  templateUrl: './lock-modal.component.html',
  styleUrls: ['./lock-modal.component.scss'],
})
export class LockModalComponent {
  public reason: FormControl = new FormControl<string>('', [Validators.required]);
  // Значение нативного input[type=datetime-local] (локальное время, без таймзоны).
  public expiresAt: FormControl = new FormControl<string>('');
  public readonly isLocking: boolean;

  constructor(
    private dialogRef: MatDialogRef<LockModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: { isLocking: boolean },
  ) {
    this.isLocking = !!data?.isLocking;
  }

  public confirm(): void {
    // Срок имеет смысл только при УСТАНОВКЕ лока; пустое поле = бессрочно (null).
    const expiresAt: string | null =
      this.isLocking && this.expiresAt.value
        ? new Date(this.expiresAt.value).toISOString()
        : null;

    const result: LockModalResult = {reason: this.reason.value, expiresAt};
    this.dialogRef.close(result);
  }

  public close(): void {
    this.dialogRef.close(false);
  }
}
